$(document).ready(function() {
    $('[data-open-sidebar]').on('click', function() {
        $('.page-sidebar, .page-content').toggleClass('sidebar-open');
        $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
    });

    function copyToClipboard(element) {
		var oldValue = $(element).html();

		navigator.clipboard.writeText(oldValue);

		$(element).html("COPIADO");
		setTimeout(function () {
			$(element).html(oldValue);
		}, 300);
	}

	$(document).on("click", "cupom", function (e) {
		e.preventDefault();
		e.stopPropagation();
		copyToClipboard(this);
	});
});
